<template>
	<div class="header bg-[#EEEEEE] sticky w-full top-0 z-30">
		<div
			class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto h-7  flex  items-center justify-between">
			<div class="headerLeft flex items-center text-[14px]">

				<el-select v-model="value" :placeholder="langInfo.please_select" @change="changeLang">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>

				<!-- <img class="size-2.5 mr-5" src="@/static/image/icon01.png" alt="" srcset="" /> -->
				<div v-if="JSON.stringify(userInfo)=='{}'" class="text-[#FF0000] flex items-center">
					<label class="cursor-pointer" @click="goLogin()">{{langInfo.head_login}}～</label>
					<label></label>
					<label class="cursor-pointer" @click="goRegister()">｜{{langInfo.head_reg}}</label>
				</div>
				<div v-else class="text-[#FF0000] flex items-center">
					{{langInfo.head_welcome}}，{{userInfo.username}}～
				</div>
				<label v-if="userInfo.id" class="text-black cursor-pointer" @click="logOutClick()">｜
					{{langInfo.head_login_out}}</label>
			</div>
			<div class="text-black  text-[14px]">
				<label class="cursor-pointer" @click="goUserCenter()">{{langInfo.head_center}}</label>

				｜<label class="cursor-pointer" @click="goOrderList()">{{langInfo.head_order}}</label>｜<label
					class="cursor-pointer" @click="goCart()">{{langInfo.head_cart}}</label>｜<label
					class="cursor-pointer" @click="goNotice()">{{langInfo.head_notice}}</label>
			</div>
		</div>
		<div class="bg-white">
			<div
				class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container h-[82px]  mx-auto flex  items-center justify-between">

				<el-image class="w-[71px] h-[71px] cursor-pointer" @click="backIndex()" :src="url_logo"
					fit="contain"></el-image>
				<div class=" flex-1 flex  text-center items-center justify-center">
					<label @click="navItemClick(item,index)" :class="[current==index?'text-[#3894FF] font-bold':'']"
						class=" text-sm text-center cursor-pointer navItem" v-for="(item,index) in  navList"> <label
							v-if="index!=5"
							class=" mr-[20px] text-center cursor-pointer whitespace-nowrap">{{item.label}}</label>
					</label>
					<router-link :to="{path:'/agreement',query: { mark: 'ContactUs' }}"
						class="text-sm text-[#545C63]  whitespace-nowrap no-underline mr-[20px]"
						target="_blank">{{langInfo['Contact us']}}</router-link>
					<router-link :to="{path:'/agreement',query: { mark: 'AboutUs' }}"
						class="text-sm text-[#545C63] no-underline whitespace-nowrap"
						target="_blank">{{langInfo['AboutUs']}}</router-link>
				</div>

				<div class=" bg-[#F3F5F6] rounded-sm px-2.5 py-2 flex  items-center">
					<el-input v-model="name" @input="inputName" @change="changeInput"
						:placeholder="langInfo.head_search_tip" class="w-full mr-[10px] search"></el-input>
					<!-- <input type="text" v-model="name" @input="inputName"   @change="changeInput" /> -->
					<img class="w-[20px] h-[20px] cursor-pointer" src="@/static/image/icon02.png" alt="" srcset="" />
				</div>
			</div>
		</div>





	</div>
</template>

<script>
	import { EventBus } from '../js/event-bus.js';
	export default {
		name: 'Header',
		data() {
			return {
				current: 0,
				options: [{
					value: 'zh',
					label: '' //中文
				}, {
					value: 'en',
					label: '' //英文
				}, {
					value: 'cht',
					label: '' //繁体
				}],
				value: 'zh',
				selectValue: "",


				navList: [{
						label: '', //首页
						path: '/'
					},
					{
						label: '', //课程中心
						path: '/courseCenter'
					},
					{
						label: '', //资讯中心
						path: '/newsCenter'
					},
					{
						label: '', //资源下载
						path: '/resourceDownload'
					},
					{
						label: '', //学习中心
						path: '/studyCenter/newStudyCenter'
					},
					{
						label: '', //智能问答
						path: '/chat'
					},
					{
						label: '', //APP下载
						path: '/navAppDownload'
					}
				],

				userInfo: {},
				langInfo: {},
				url_logo: '',
				name: '',
				system_app: '',
				isMobile: false, //默认为pc端


			}
		},

		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log("监听==="); // 获取查询参数
				console.log(to);
			}
		},
		mounted() {

			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				//如果flag不为空，说明可以匹配到，是手机端
				this.isMobile = true
				console.log("this.isMobile===" + this.isMobile);
				// this.$router.replace({
				// 	path: '/APPDownload',
				// })


				//香港的h5路径：kaoshi.51exampass.com/h5/#/

				// 大陆h5路径 portal.51jobpass.com/h5/#/
				// 测试h5  ceshi.51exampass.com/h5/#/


				window.open('https://kaoshi.51exampass.com/h5/#/', '_self')

				return
			}

			if (this.$route.fullPath.indexOf('/courseCenter') > -1) {
				console.log("搜索===");
				console.log(this.$route.query.name);
				this.name = this.$route.query.name
			}
			if (this.$route.fullPath.indexOf('/courseCenter') > -1) {
				this.current = 1
			}
			if (this.$route.fullPath.indexOf('/courseDetail') > -1) {
				this.current = 1
			}
			if (this.$route.fullPath.indexOf('/newsDetail') > -1) {
				this.current = 2
			}
			if (this.$route.fullPath.indexOf('/resourceDetail') > -1) {
				this.current = 3
			}

			this.value = localStorage.getItem('lang') || 'zh';

			console.log("this.value===" + this.value);
			this.navList.forEach((item, index) => {
				if (this.$route.fullPath == item.path) {
					this.current = index
				}
			})
			console.log("localStorage.getItem('userInfo')====");

			if (localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
				this.getUserInfo()
			} else {
				this.getUserInfo()
			}



			this.langInfo = this.$store.getters['lang/getLangList']

			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.setNav()
			}
			this.getconfig()
			EventBus.$on('userInfo', (res) => {
				console.log("res========");
				console.log(res);
				this.userInfo = res
			})

		},
		methods: {



			inputName(e) {
				console.log(e);
				this.name = e
			},
			changeInput(e) {
				console.log(e);
				console.log("回车");

				this.$router.replace({
					path: '/courseCenter',
					query: {
						name: this.name
					}
				})
			},
			getconfig() {
				this.$api.config({}).then((res) => {
					console.log(res);
					this.url_logo = res.data.url_logo
					this.system_app = res.data.system_app



					var link = document.querySelector("link[rel~='icon']");
					if (!link) {
						link = document.createElement('link');
						link.rel = 'icon';
						document.head.appendChild(link);
					}
					link.href = this.url_logo
				}).catch((error) => {
					if (error.code == 450) {
						localStorage.removeItem('userInfo')
						localStorage.removeItem('token')
						this.$router.go(0)
					}
				})
			},
			setNav() {
				this.navList[0].label = this.langInfo.head_home_nav
				this.navList[1].label = this.langInfo.head_class_nav
				this.navList[2].label = this.langInfo.head_news_nav
				this.navList[3].label = this.langInfo.head_download_nav
				this.navList[4].label = this.langInfo.head_study_nav
				this.navList[5].label = this.langInfo.head_ai_nav
				this.navList[6].label = this.langInfo.APP_download




				this.options[0].label = this.langInfo.zh
				this.options[1].label = this.langInfo.en
				this.options[2].label = this.langInfo.cht
			},
			// 设置语言
			changeLang(e) {
				console.log(e);
				this.selectValue = e
				this.dict_data_cq()
			},
			dict_data_cq() {
				this.$api.dict_data_cq({
					lang: this.selectValue
				}).then((res) => {
					console.log(res);
					if (res.code == 1) {
						this.value = this.selectValue
						this.selectValue = ""
						localStorage.setItem('lang', this.value)
						location.reload();
						this.getdict_data()
					} else {
						this.selectValue = localStorage.getItem('lang') || 'zh'
						this.value = localStorage.getItem('lang') || 'zh'
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.selectValue = localStorage.getItem('lang') || 'zh'
					this.value = localStorage.getItem('lang') || 'zh'

					console.log("this.selectValue==" + this.selectValue);

					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})

					this.langInfo = obj
					this.setNav()
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					localStorage.setItem('userInfo', JSON.stringify(res.data))
				}).catch((error) => {
					this.userInfo = {}

					localStorage.removeItem('userInfo')
					localStorage.removeItem('token')
				})

			},
			goLogin() {
				localStorage.removeItem('userInfo')
				localStorage.removeItem('token')
				this.$router.replace({
					path: '/login',
					query: {
						tabIndex: 0
					}
				})
			},
			goRegister() {
				localStorage.removeItem('userInfo')
				localStorage.removeItem('token')
				this.$router.replace({
					path: '/login',
					query: {
						tabIndex: 1
					}
				})
				// this.$router.replace({ path: '/register' })
			},
			navItemClick(item, index) {

				if (index == 4) {
					if (!localStorage.getItem('token')) {
						this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
							confirmButtonText: this.langInfo['Log in'],
							cancelButtonText: this.langInfo.cancel,
							type: 'warning'
						}).then(() => {
							this.$router.push({ path: '/login' })
						}).catch(() => {

						});
						return
					}
				}

				// if (index == 6) {
				// 	window.location.href = this.system_app
				// 	return
				// }
				if (item.path == "/chat") {
					window.open("#" + item.path, '_blank')
					return
				}
				this.current = index
				if (item.path) {
					console.log(this.$route);
					console.log(item.path);

					if (this.$route.fullPath === item.path) {
						// 如果相同则不进行导航
						return;
					}
					console.log("this.current===" + this.current);
					this.$router.push(item.path); // 使用完整路径
				}
			},
			// 退出登录
			logOutClick() {
				this.$api.logout().then((res) => {
					console.log(res.data);
					localStorage.removeItem('userInfo')
					localStorage.removeItem('token')
					this.$router.push({ path: '/login' })
				}).catch((error) => {
					localStorage.removeItem('userInfo')
					localStorage.removeItem('token')
					this.$router.push({ path: '/login' })
				})
			},
			backIndex() {
				if (this.$route.fullPath == '/') {
					return
				}
				this.$router.replace({ path: '/' });
			},
			// 个人中心
			goUserCenter() {
				if (!localStorage.getItem('token')) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						this.$router.push({ path: '/login' })
					}).catch(() => {

					});
					return
				}




				if (this.$route.path.indexOf('/personalCenter/personalSet') > -1) {
					return
				}
				this.$router.replace({
					path: '/personalCenter/personalSet/baseInfo',
					query: {
						type: 0
					}
				})
			},
			// 订单列表
			goOrderList() {



				if (!localStorage.getItem('token')) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						this.$router.push({ path: '/login' })
					}).catch(() => {

					});
					return
				}



				if (this.$route.path == '/personalCenter/orderList') {
					return
				}
				this.$router.replace({
					path: '/personalCenter/orderList',
					query: {
						type: 0
					}
				})
			},
			// 购物车列表
			goCart() {

				if (!localStorage.getItem('token')) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						this.$router.push({ path: '/login' })
					}).catch(() => {

					});
					return
				}

				if (this.$route.path == '/personalCenter/cart') {
					return
				}
				this.$router.replace({
					path: '/personalCenter/cart',
					query: {
						type: 0
					}
				})
			},
			// 消息中心
			goNotice() {
				if (!localStorage.getItem('token')) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						this.$router.push({ path: '/login' })
					}).catch(() => {

					});
					return
				}


				if (this.$route.path.indexOf('/personalCenter/notice') > -1) {
					return
				}
				this.$router.replace({
					path: '/personalCenter/notice/system?type=1',
					query: {
						type: 0
					}
				})
			}
		}

	}
</script>

<style scoped>
	/deep/.el-input input {
		padding-right: 0;
		background-color: transparent;
		border: 0;
	}

	/deep/.headerLeft .el-input input {
		width: 80px;
	}

	.search {
		height: 20px;
		width: 100%;
	}

	/deep/.search .el-input__inner {
		width: 100%;
		height: 100%;
	}

	input {
		border: none;
		background-color: transparent;
	}

	input::placeholder {
		color: #A6A6A6;
		/* 例如，设置为灰色 */
	}

	.navItem:nth-last-child(1) {
		margin-right: 0;
	}
</style>